import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setVersionHandler } from "../../HandleSlice/HandleSlice";

const CustomUpdateToast = ({ text, btnText }) => {
  const [newModalState, setNewModalState] = useState(false);
  const dispatch = useDispatch();
  const versionPack = useSelector((state) => state.hamberger.version);
  const location = window.location.href;

  const versionClickHandler = () => {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
      localStorage.setItem("version", versionPack.version);
      localStorage.removeItem("customUpdateState");
      window.location.reload(true);
    }
  };

  const checkVersion = () => {
    let version = localStorage.getItem("version");

    axios.get(location + "version.json").then((res) => {
      if (version === null) {
        versionClickHandler();
      } else if (version !== res.data.version) {
        if (localStorage.getItem("customUpdateState") !== "true") {
          dispatch(setVersionHandler(res.data));
        }
        setNewModalState(true);
        localStorage.setItem("customUpdateState", "true");
      }
    });
  };

  const closeVersionModal = () => {
    localStorage.setItem("customUpdateState", "false");
    localStorage.setItem("version", versionPack.version);
    setNewModalState(false);
  };

  useEffect(() => {
    checkVersion();
  }, []);

  return (
    <Fragment>
      {localStorage.getItem("customUpdateState") === "true" || newModalState ? (
        <>
          <div
            className="fixed w-full h-full backdrop-blur-sm top-0 z-[1000000000]"
            onClick={closeVersionModal}
          ></div>
          <div className="fixed backdrop-blur-[200px] bg-white shadow rounded-lg md:w-[400px] w-[224px] md:h-[300px] h-[224px] inset-0 m-auto z-[1000000000]">
            <div className="pr-4 pt-2">
              <i
                className="fa fa-times cursor-pointer"
                aria-hidden="true"
                onClick={closeVersionModal}
              />
            </div>
            <div>
              <ul className={"h-[148px] md:h-[223px] overflow-y-scroll"}>
                {versionPack &&
                  versionPack.changes.map((item) => (
                    <li className="mx-4">
                      <h1 className="font-bold">
                        <span>ورژن</span> {Object.keys(item)[0]}
                      </h1>
                      <ul>
                        {item[Object.keys(item)[0]].map((changes) => (
                          <li className="text-[14px]">- {changes}</li>
                        ))}
                      </ul>
                    </li>
                  ))}
              </ul>
              <div className="flex items-center pr-4 absolute gap-4 bottom-0 h-[40px] w-full bg-stone-100 text-[14px] text-white">
                <button
                  className="bg-green-600 px-4 h-[30px] rounded-lg"
                  onClick={versionClickHandler}
                >
                  به روز رسانی
                </button>
                <button
                  className="bg-red-600 px-4 h-[30px] rounded-lg"
                  onClick={closeVersionModal}
                >
                  لغو
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default CustomUpdateToast;
